import { useCallback } from "react";

import { ChevronLeft, ChevronRight, LoaderCircle } from "lucide-react";

import { Button } from "@/components/ui/button";

export function Pagination({
  total,
  page,
  size,
  onPageChange,
  pageLoading,
}: {
  total: number;
  page: number;
  size: number;
  onPageChange: (page: number) => void;
  pageLoading: boolean;
}) {
  const totalPages = Math.ceil(total / size);
  const startIndex = Math.min((page - 1) * size + 1, total);
  const endIndex = Math.min(page * size, total);
  const handlePreviousPage = useCallback(() => {
    onPageChange(page - 1);
  }, [onPageChange, page]);
  const handleNextPage = useCallback(() => {
    onPageChange(page + 1);
  }, [onPageChange, page]);
  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        intent="secondary"
        size="icon"
        onClick={handlePreviousPage}
        disabled={page <= 1}
      >
        {pageLoading ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          <ChevronLeft className="h-4 w-4" />
        )}
      </Button>
      <span className="text-sm text-gray-800">
        {startIndex} - {endIndex} of {total}
      </span>
      <Button
        intent="secondary"
        size="icon"
        onClick={handleNextPage}
        disabled={page >= totalPages}
      >
        {pageLoading ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          <ChevronRight className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
